<template>
  <div :class="{fullscreen:fullscreen}" class="tinymce-container editor-container">
    <textarea :id="tinymceId" class="tinymce-textarea"/>
    <!--<div class="editor-custom-btn-container">-->
      <!--<editorImage color="#1890ff" class="editor-upload-btn" @successCBK="imageSuccessCBK"/>-->
    <!--</div>-->
  </div>
</template>

<script>
import editorImage from './components/editorImage'
import plugins from './plugins'
import toolbar from './toolbar'
import {getQiniuUploadToken} from "@/api/site"
import axios from 'axios'

export default {
  name: 'Tinymce',
  components: { editorImage },
  props: {
    id: {
      type: String,
      default: function() {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
      }
    },
    value: {
      type: String,
      default: ''
    },
    plugins: {
      type: [String, Array],
      default: 'lists image link media table textcolor wordcount contextmenu paste'
    },
    toolbar: {
      type: [String, Array],
      default: 'undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image link media fontsizeselect fontselect table | removeformat'
    },
    /*toolbar: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },*/
    menubar: {
      type: String,
      default: 'file edit insert view format table'
    },
    height: {
      type: Number,
      required: false,
      default: 360
    }
  },
  data() {
    return {
      resimg:'',
      resVideo:'',
      uploaded: false,
      QiniuData: {
        key: "",
        token: "",
      },
      domain: "http://up-z1.qiniup.com",
      qiniuaddr: "http://image.bjh.snsports.cn",
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        'en': 'en',
        'zh': 'zh_CN'
      }
    }
  },
  computed: {
    language() {
      return this.languageTypeList[this.$store.getters.language]
    }
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() =>
          window.tinymce.get(this.tinymceId).setContent(val || ''))
      }
    },
    language() {
      this.destroyTinymce()
      this.$nextTick(() => this.initTinymce())
    }
  },
  mounted() {
    this.getQiniuToken()
    this.initTinymce()
  },
  activated() {
    this.initTinymce()
  },
  deactivated() {
    this.destroyTinymce()
  },
  destroyed() {
    this.destroyTinymce()
  },
  methods: {
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        this.QiniuData.token = response.data.token
        console.log(this.QiniuData.token)
      }).catch(err => {
        console.log(err, 'error', '七牛Token获取失败')
      })
    },
    /*imgUpload(blobInfo, success, failure){
      console.log(blobInfo)
      const axiosInstance = axios.create({ withCredentials: false })
      let data = new FormData()
      console.log(blobInfo.blob())
      data.append("file", blobInfo.blob())
      data.append("token", this.QiniuData.token)
      axiosInstance({
        method: "POST",
        url: this.domain, //上传地址
        data: data,
        timeout: 30000, //超时时间，因为图片上传有可能需要很久
        onUploadProgress: progressEvent => {
          //imgLoadPercent 是上传进度，可以用来添加进度条
          let imgLoadPercent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
      })
      .then(data => {
        console.log(data)
      // 调用成功回调，返回用七牛外链地址和返回的key拼接的图片路径
        success(`${this.qiniuaddr}/${data.data.key}`)
      })
      .catch(function(err) {
        //上传失败
      })
    },*/
    uploadImg(file,type){
        // console.log(token,file,type,)
      let content = file
      let formData = new FormData();
      formData.append('file', content);
      formData.append("token", this.QiniuData.token)
      axios({
          method: "post",
          //服务器上传地址
          url: this.domain,
          data: formData,
          headers: {
          // 修改请求头
          "Content-Type": "multipart/form-data"
          }
      }).then(res => {
          console.log(res);
          if(res.data){
            if(type == 'image') {
                this.resimg = this.qiniuaddr + '/' + res.data.key
                console.log(this.resimg)
            }else if (type == 'media'){
                this.resVideo = this.qiniuaddr + '/' + res.data.key
                console.log(this.resVideo)
            }
            this.uploaded = true
          }
        })
    },
    resstData() {
        this.resVideo = '',
        this.uploaded =  false
    },
    initTinymce() {
      const _this = this
      window.tinymce.init({
        language: this.language,
        selector: `#${this.tinymceId}`,
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: false,
        fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
        toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
        menubar: this.menubar,
        plugins: plugins,
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        force_br_newlines : true,
         paste_data_images: true,
        force_p_newlines : false,
        forced_root_block:'',
        nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        init_instance_callback: editor => {
          if (_this.value) {
            editor.setContent(_this.value)
          }
          _this.hasInit = true
          editor.on('NodeChange Change KeyUp SetContent', () => {
            this.hasChange = true
            this.$emit('input', editor.getContent())
          })
        },
        setup(editor) {
          editor.on('FullscreenStateChanged', (e) => {
            _this.fullscreen = e.state
          })
        },
        file_picker_types: 'image media',
        file_picker_callback: (callback, value, meta)=> {
          if (meta.filetype == 'image') {
            let input = document.createElement('input')
            input.setAttribute('type', 'file');
            // let that = this;
            input.onchange = function(){
              let file = this.files[0]
              //_this.uploadImg(file,'image')
              // 插入代码
              let type = 'image'
              let content = file
              let formData = new FormData();
              formData.append('file', content);
              formData.append("token", _this.QiniuData.token)
              axios({
                  method: "post",
                  //服务器上传地址
                  url: _this.domain,
                  data: formData,
                  headers: {
                  // 修改请求头
                  "Content-Type": "multipart/form-data"
                  }
              }).then(res => {
                  console.log(res);
                  if(res.data){
                    _this.resimg = _this.qiniuaddr + '/' + res.data.key
                    console.log(_this.resimg)
                    _this.uploaded = true
                    if(_this.uploaded){
                      // _this.resVideo, 
                      console.log(_this.resimg,'true')
                      callback(_this.resimg)
                    }else{
                      console.log(_this.resimg,'false')
                      callback(_this.resimg)
                    }
                  }
                })
              // 插入代码结束
            }
            //触发点击
            input.click();
          }
          if (meta.filetype == 'media') {
            let input = document.createElement('input')
            input.setAttribute('type', 'file');
            // let that = this;
            input.onchange = function(){
                let file = this.files[0]
                // console.log(file)
               let type = 'image'
              let content = file
              let formData = new FormData();
              formData.append('file', content);
              formData.append("token", _this.QiniuData.token)
              axios({
                  method: "post",
                  //服务器上传地址
                  url: _this.domain,
                  data: formData,
                  headers: {
                  // 修改请求头
                  "Content-Type": "multipart/form-data"
                  }
              }).then(res => {
                  console.log(res);
                  if(res.data){
                    _this.resVideo = _this.qiniuaddr + '/' + res.data.key
                    console.log(_this.resVideo)
                    _this.uploaded = true
                    if(_this.uploaded){
                      // _this.resVideo, 
                      console.log(_this.resimg,'true')
                      callback(_this.resVideo)
                    }else{
                      console.log(_this.resimg,'false')
                      callback(_this.resVideo)
                    }
                  }
                })
            }
            //触发点击
            input.click();
          }
        },
        /*images_upload_handler: (blobInfo, success, failure) => {
          this.imgUpload(blobInfo, success, failure)
        }*/

        // 整合七牛上传
        // images_dataimg_filter(img) {
        //   setTimeout(() => {
        //     const $image = $(img);
        //     $image.removeAttr('width');
        //     $image.removeAttr('height');
        //     if ($image[0].height && $image[0].width) {
        //       $image.attr('data-wscntype', 'image');
        //       $image.attr('data-wscnh', $image[0].height);
        //       $image.attr('data-wscnw', $image[0].width);
        //       $image.addClass('wscnph');
        //     }
        //   }, 0);
        //   return img
        // },
        // images_upload_handler(blobInfo, success, failure, progress) {
        //   progress(0);
        //   const token = _this.$store.getters.token;
        //   getToken(token).then(response => {
        //     const url = response.data.qiniu_url;
        //     const formData = new FormData();
        //     formData.append('token', response.data. _token);
        //     formData.append('key', response.data.qiniu_key);
        //     formData.append('file', blobInfo.blob(), url);
        //     upload(formData).then(() => {
        //       success(url);
        //       progress(100);
        //     })
        //   }).catch(err => {
        //     failure('出现未知问题，刷新页面，或者联系程序员')
        //     console.log(err);
        //   });
        // },
      })
    },
    destroyTinymce() {
      const tinymce = window.tinymce.get(this.tinymceId)
      if (this.fullscreen) {
        tinymce.execCommand('mceFullScreen')
      }

      if (tinymce) {
        tinymce.destroy()
      }
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value)
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent()
    },
    imageSuccessCBK(arr) {
      const _this = this
      arr.forEach(v => {
        window.tinymce.get(_this.tinymceId).insertContent(`<img class="wscnph" src="${v.url}" >`)
      })
    }
  }
}
</script>

<style scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}
.tinymce-container>>>.mce-fullscreen {
  z-index: 10000;
}
.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}
.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
  /*z-index: 2005;*/
}
.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}
.editor-upload-btn {
  display: inline-block;
}
</style>
